import React from "react";

// ===================================================================
// The Crowd v2 — Bibliotheques : badge de statut, valeur d'un champ
//
// Utilises par le bandeau de fiche et par le tableau de bord. Couleurs
// de feedback du theme (succes, alerte, danger) ; les statuts sans
// signification d'alerte restent neutres. « En cours » est neutre
// marque, pour se distinguer d'« En attente ».
// ===================================================================

export const STATUTS = ["Termine", "En cours", "A faire", "Bloque", "En attente", "Cadrage", "Reflexion", "Partiel", "Implemente"];

const TONALITE_STATUT = {
  Termine: "success",
  Implemente: "success",
  "A faire": "warning",
  Partiel: "warning",
  Bloque: "danger",
  "En cours": "fort",
  "En attente": "neutre",
  Cadrage: "neutre",
  Reflexion: "neutre",
};

export function BadgeStatut({ status }) {
  const ton = TONALITE_STATUT[status] || "neutre";
  return <span className={`v2-statut v2-statut-${ton}`}>{status}</span>;
}

// Rendu d'une valeur selon le type declare dans _config.json
// (badge, progress, score, boolean, texte). `compact` : variante tableau.
export function ValeurChamp({ type, valeur, compact = false }) {
  if (!valeur && valeur !== 0) return <span className="v2-valeur-vide">—</span>;
  const v = String(valeur).replace(/[[\]`]/g, "").trim();

  switch (type) {
    case "badge":
      return <BadgeStatut status={v} />;

    case "progress": {
      const n = parseInt(v, 10) || 0;
      const ton = n >= 80 ? "success" : n >= 50 ? "fort" : "warning";
      return (
        <span className={`v2-progression${compact ? " v2-progression-compacte" : ""}`}>
          <span className="v2-progression-piste">
            <span className={`v2-progression-valeur v2-ton-${ton}`} style={{ width: `${Math.min(n, 100)}%` }} />
          </span>
          <span className="v2-progression-texte">{n}%</span>
        </span>
      );
    }

    case "score":
      return <span className="v2-valeur-score">{v}</span>;

    case "boolean":
      return (
        <span className={`v2-statut ${v === "true" ? "v2-statut-danger" : "v2-statut-neutre"}`}>
          {v === "true" ? "Oui" : "Non"}
        </span>
      );

    default:
      return <span>{v}</span>;
  }
}
